"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputProperties = exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

var _baseColors2 = _interopRequireDefault(require("./baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var input = {
  background: 'transparent',
  backgroundReadOnly: '#F3F4F4',
  border: _baseColors["default"].ashGrey,
  borderHover: _baseColors["default"].denim,
  borderFocus: _baseColors["default"].denim,
  borderError: _baseColors["default"].mordantRed,
  icon: '#A2A2A2',
  text: _baseColors2["default"].black,
  placeholder: _baseColors["default"].outline["default"],
  placeholderDisabled: _baseColors2["default"].black,
  placeholderReadOnly: _baseColors2["default"].black,
  label: _baseColors2["default"].atomic,
  labelDisabled: _baseColors2["default"].black
};
var inputProperties = {
  boxShadow: false,
  labelFontSize: '14px',
  errorCasing: 'initial',
  labelType: 'static',
  radius: '2px',
  errorSize: '12px',
  height: {
    large: '32px',
    "default": '32px',
    medium: '27px'
  },
  iconStyle: {
    top: {
      "default": '29px',
      withLabel: {
        noBorder: '25px',
        medium: '20px',
        mediumBordered: '26px'
      },
      withoutLabel: {
        "default": '9px',
        mediumBordered: '4px'
      },
      bordered: {
        "default": '20px',
        withLabel: {
          noBorder: '25px',
          medium: '20px',
          mediumBordered: '20px'
        },
        withoutLabel: {
          "default": 0,
          mediumBordered: '4px'
        }
      }
    }
  }
};
exports.inputProperties = inputProperties;
var _default = input;
exports["default"] = _default;